import { render, staticRenderFns } from "./CLoading.vue?vue&type=template&id=47d11f95&scoped=true"
import script from "./CLoading.vue?vue&type=script&lang=js"
export * from "./CLoading.vue?vue&type=script&lang=js"
import style0 from "./CLoading.vue?vue&type=style&index=0&id=47d11f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d11f95",
  null
  
)

export default component.exports